import { Component, OnInit } from '@angular/core';
import { AlertService } from 'src/app/_services/alert.service';
import { MenusService } from 'src/app/_services/menu.service';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ColDef, GridApi, GridReadyEvent, PaginationChangedEvent, RowClickedEvent, ITooltipParams, Column, GridOptions } from 'ag-grid-community';
import { BtnCellRenderer } from 'src/app/common/button-cell-renderer.component';
import { BtnCellRenderer1 } from 'src/app/common/button-cell-renderer.component1';
const { defaultPageSizeArr, defaultPageSize } = environment;
import * as moment from 'moment'; // Import Moment.js
import { FormGroup, FormControl, Validators, FormBuilder, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { CmaService } from './cma.service';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { PiiCellRendererComponent } from 'src/app/common/pii-cell-renderer.component';
import { PiiGridService } from 'src/app/_services/pii-grid.service';
 
@Component({
  selector: 'app-cma-statement-report',
  templateUrl: './cma-statement-report.component.html',
  styleUrls: ['./cma-statement-report.component.scss']
})
export class CmaStatementReportComponent implements OnInit {
  cmaForm: FormGroup;
  submitted = false;
  public permissions: any = '';
 
  // fromDate: string = '';
  // toDate: string = '';
  // accountNumber: string = '';
  private gridApi!: GridApi;
  private gridColumnApi!: any;
  globalSearch: string = '';
  searchKey: string = '';
 
  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 150,
    resizable: true,
    sortable: true,
    filter: false,
    autoHeight: true
  };
 
  public defaultColDef1: ColDef = {
    flex: 1,
    minWidth: 220,
    resizable: true,
    sortable: true,
    filter: false,
    autoHeight: true
  };
 
  collectionSize: number = 0;
  pageSize: number = defaultPageSize;
  pageRecords: number = defaultPageSize;
  pageSizeArr: any = defaultPageSizeArr;
  pageNumber: number = 1;
  rowData: any = [];
  collectiondata: number = 0;
  currentPage: number = 0;
  requestPageNumber: number = 1;
  statementCollectionSize: number = 0;
  requestCollectionSize: number = 0;
  isQuickFilter: boolean = false;
  currentDate: string;
  toCurrentDate: string;
  fromCurrentDate: string;
  public gridOptions: GridOptions;
 
 
  statementColumnDefs: ColDef[] = [
      { field: 'accountNumber', headerName: 'Account Number',cellRenderer: PiiCellRendererComponent, width: 250, minWidth: 200},
      { field: 'refNumber', headerName: 'Reference Number' },
      { field: 'txnId', headerName: 'Ref ID' },
      { field: 'amount', headerName: 'Amount',cellRenderer: PiiCellRendererComponent, width: 250, minWidth: 200},
      { field: 'transactionType', headerName: 'Transaction Type' },
      { field: 'transactionCode', headerName: 'Transaction Code' },
      { field: 'runningBalance', headerName: 'Running Balance',cellRenderer: PiiCellRendererComponent, width: 250, minWidth: 200},
      { field: 'postedBranchCode', headerName: 'Posted Branch Code' },
      { field: 'branchCode', headerName: 'Branch Code' },
      { field: 'currencyCode', headerName: 'Currency Code' },
      { field: 'channelId', headerName: 'Channel ID' },
      { field: 'postedDateTime', headerName: 'Posted Date', valueGetter: (params:any) => this.formatDate(params.data.postedDateTime) },
      { field: 'valueDateTime', headerName: 'Value Date', valueGetter: (params:any) => this.formatDate(params.data.valueDateTime) },
      { field: 'dateTime', headerName: 'Date', valueGetter: (params:any) => this.formatDate(params.data.dateTime) },
      { field: 'description', headerName: 'Detail' },
      { field: 'narration1', headerName: 'Narration 1' },
      { field: 'narration2', headerName: 'Narration 2' },
      { field: 'narration3', headerName: 'Narration 3' },
      {
        field: 'unmasking',
        headerName: 'Unmasking',
        lockVisible: true, 
        width: 120, 
        cellRenderer: BtnCellRenderer1, 
        cellRendererParams: [
          {
            clicked: async (event: any, param: any) => {
              // Toggle PII unmask for the entire row
              this.piiGridService.unmaskRow(param.data, this.gridApi);
            },
            buttonIconClass: 'icon-frame-1',
            buttonText: '',
            buttonVisible: true,
            customImage: 'assets/images/unmask-icon.png'
          }
        ]
      }
    ];

  requestColumnDefs: ColDef[] = [
    {
      field: 'fromDateTime',
      headerName: 'From Date',
      valueFormatter: (params) => new Date(params.value).toLocaleString() // Format the date
    },
    {
      field: 'toDateTime',
      headerName: 'To Date',
      valueFormatter: (params) => new Date(params.value).toLocaleString() // Format the date
    },
    { field: 'accountNo', headerName: 'Account Number' }, // Assuming you will add this field in your data
    {
      field: 'createdOn',
      headerName: 'Created On',
      valueFormatter: (params) => new Date(params.value).toLocaleString() // Format the date
    },
    { field: 'status', headerName: 'Status' }
  ];
 
 
 
 
 
  totalRecords: any;
  requestRowData: any = [];
 
    constructor(
      private _CMS: CmaService,
      private alertService: AlertService, 
      private _FB: FormBuilder,
      private menuService: MenusService,
      private location: Location,
      private router: Router,
      private piiGridService: PiiGridService
    ) {
      this.gridOptions = <GridOptions>{};
      const now = new Date();
      this.currentDateTime = now.toISOString().slice(0, 16); 
    }
 
   async ngOnInit(): Promise<void> {
    const path = this.location.prepareExternalUrl(this.location.path());
    this.permissions = this.menuService.getPermissions(path);
    console.log(this.permissions)
     if (this.permissions == null || this.permissions == '' || !this.permissions) {
       this.alertService.errorAlert({
         title: "No Access",
         backdrop: true,
         toast: true,
         timer: 1500
       })
       await this.router.navigateByUrl('/');
     }

     const now = new Date();
     this.currentDate = now.toISOString().slice(0, 16);  // "YYYY-MM-DDTHH:mm"
     this.toCurrentDate = now.toISOString().slice(0, 16);
   // this.fromCurrentDate = this.currentDate;  // Initialize fromCurrentDate
    
    this.cmaForm = this._FB.group(
      {
        fromDate: ['', Validators.required],
        toDate: ['', [Validators.required]],
        accountNumber: [null, [Validators.required]]
      },
      
    );
    
    this.getAccounts();
    this.searchRequest();
  }
  
   formatDate(timestamp: number): string {
    const date = new Date(timestamp);
    const day = ("0" + date.getDate()).slice(-2);
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear().toString().slice(-2);
    const hours = ("0" + date.getHours()).slice(-2);
    const minutes = ("0" + date.getMinutes()).slice(-2);
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  }

  changeFromDate(eve:any){
    this.fromCurrentDate=eve.target.value;
    this.cmaForm.get('toDate')?.reset('');
  }
 
  changeToDate(eve:any){
    debugger
    this.fromCurrentDate=eve.target.value;
   
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.showLoadingOverlay();
    this.rowData = [];
  }
 
  onGridReadyRequest(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.showLoadingOverlay();
    const allColumnIds: (string | Column)[] = [];
    params?.columnApi?.getColumns()?.forEach((column) => {
      allColumnIds.push(column.getId());
    });
    params?.columnApi?.autoSizeColumns(allColumnIds, false);
    this.requestRowData = [];
   
    this.searchRequest();
  }
 
  accountData: any = [];
  getAccounts() {
    this._CMS.getAccounts().subscribe((res: any) => {
      this.accountData = res.response.data;
    });
  }
 
  onPageSizeChanges(eve: any) {
    this.pageNumber = 1;
    this.searchStatement();
  }
 
  onPageSizeChangesRequest(eve: any) {
    this.requestPageNumber = 1;
    this.searchRequest();
  }
 
  onPaginationChange(param: PaginationChangedEvent | any) {
    this.pageNumber = param;
    debugger
    this.searchStatement();
  }
 
  onPaginationChangeRequest(param: PaginationChangedEvent | any) {
    debugger
    this.requestPageNumber = param;
    this.searchRequest();
  }
 
 
  get cmaFormControls() {
    return this.cmaForm.controls;
  }
 
  searchStatement() {
    this.submitted = true; // Set submitted flag to trigger error display
    this.cmaForm.markAllAsTouched(); // Mark all fields as touched to display validation errors
 
    if (this.cmaForm.valid) {
      let fromDateTimestamp = this.cmaFormControls.fromDate.value;
      let toDateTimestamp = this.cmaFormControls.toDate.value;
      const accountNumber = this.cmaFormControls.accountNumber.value;
 
      // Format datetime correctly
      fromDateTimestamp = fromDateTimestamp.replace('T', ' ') + ':00';
      toDateTimestamp = toDateTimestamp.replace('T', ' ') + ':00';
 
      // API Call
      this._CMS.searchStatement(this.pageSize, this.pageNumber, fromDateTimestamp, toDateTimestamp, accountNumber).subscribe(
        (data: any) => {
          console.log(data);
          this.searchRequest();
          if (data.response.data.dataAvailable == true) {
            this.getStatement(data.response.data.form.fromDateTime, data.response.data.form.toDateTime);
          }
        },
        (error) => {
          console.error("Error fetching statement:", error);
        }
      );
    }
  }

  onBackgroundExport() {
    this.submitted = true; // Set submitted flag to trigger error display
    this.cmaForm.markAllAsTouched(); // Mark all fields as touched to display validation errors
 
    if (this.cmaForm.valid) {
      let fromDateTimestamp = this.cmaFormControls.fromDate.value;
      let toDateTimestamp = this.cmaFormControls.toDate.value;
      const accountNumber = this.cmaFormControls.accountNumber.value;
 
      // Format datetime correctly
      fromDateTimestamp = fromDateTimestamp.replace('T', ' ') + ':00';
      toDateTimestamp = toDateTimestamp.replace('T', ' ') + ':00';
 
      // API Call
      this._CMS.searchStatement(this.pageSize, this.pageNumber, fromDateTimestamp, toDateTimestamp, accountNumber).subscribe(
        (data: any) => {
          console.log(data);
          this.searchRequest();
          if (data.response.data.dataAvailable == true) {
            this.getStatementToExport(data.response.data.form.fromDateTime, data.response.data.form.toDateTime);
          }
        },
        (error) => {
          console.error("Error fetching statement:", error);
        }
      );
    }
  }
 
 
  
  getStatementToExport(fromDateTimestamp:string,toDateTimestamp:string) {
    if (this.cmaForm.valid) {
      // const fromDateTimestamp = new Date(this.cmaFormControls.fromDate.value).getTime();
      // const toDateTimestamp = new Date(this.cmaFormControls.toDate.value).getTime();
      const accountNumber = this.cmaFormControls.accountNumber.value;
      this._CMS.ExportStatments( this.pageNumber-1,this.pageSize, fromDateTimestamp, toDateTimestamp, accountNumber)
      .subscribe(
        (response: any) => {
       
          console.log('Background export response:', response);
          
          if (response?.response?.status === 200) {
            const referenceId = response.response.data[" document referenceId"] || response.response.data.documentReferenceId;
            const recordsCount = response.response.data.recordsCount;
            
            this.alertService.successAlertWithAcknowledgment(
              `Your export of ${recordsCount} records has started. Reference ID: ${referenceId}`
            );
          } else if (response?.response?.status === 509) {
            this.alertService.errorAlertWithMessage(
              `Export limit exceeded: ${response.response.data.message}`
            );
          } else {
            this.alertService.errorAlertWithMessage(
              response?.response?.message || "An error occurred during export. Please try again later."
            );
          }
        },
        error => {
          
          console.error('Background export error:', error);
          
          this.alertService.errorAlertWithMessage(
            error?.response?.message || "Failed to start background export. Please try again later."
          );
        }
      );
    }
    else {
      this.submitted = true
    }
  }
 
 
  getStatement(fromDateTimestamp:string,toDateTimestamp:string) {
    if (this.cmaForm.valid) {
      // const fromDateTimestamp = new Date(this.cmaFormControls.fromDate.value).getTime();
      // const toDateTimestamp = new Date(this.cmaFormControls.toDate.value).getTime();
      const accountNumber = this.cmaFormControls.accountNumber.value;
      this._CMS.getStatement( this.pageNumber-1,this.pageSize, fromDateTimestamp, toDateTimestamp, accountNumber)
      .subscribe(
        (data: any) => {
          console.log(data);
          this.searchRequest();
          this.rowData = data.response.data.content;
          this.collectiondata = data.response.data.content;
          this.statementCollectionSize = data.response.data.totalElements;
          this.totalRecords = data.response.data.totalElements;
        });
    }
    else {
      this.submitted = true
    }
  }
 
  searchRequest() {
    this._CMS.searchRequest(this.requestPageNumber-1,this.pageRecords ).subscribe((data: any) => {
      this.requestRowData = data.response.data.content;
      this.collectiondata = data.response.data.content
      this.requestCollectionSize = data.response.data.totalElements
      this.totalRecords = data.response.data.totalElements
    });
  }
 
  formatDateWithCurrentTime(date: any): string {
    if (date) {
      // Combine selected date with current time
      const currentTime = moment().format('HH:mm:ss'); // Get current time in HH:mm:ss format
      const formattedDateTime = moment(date).set({
        hour: moment(currentTime, 'HH:mm:ss').hour(),
        minute: moment(currentTime, 'HH:mm:ss').minute(),
        second: moment(currentTime, 'HH:mm:ss').second(),
      }).format('YYYY-MM-DD HH:mm:ss');
 
      return formattedDateTime;
    }
    return '';
  }
 
  onExportCSV() {
    if (this.rowData.length) {
      let csfFile: any = this.gridOptions.api?.getDataAsCsv();
      const lines = csfFile.split('\n');
      const result: any[] = [];
      const headers = lines[0].split(',');
 
      for (let i = 1; i < lines.length; i++) {
        const row = lines[i].split(',');
        if (row.length === headers.length) {
          const obj: any = {};
          for (let j = 0; j < headers.length; j++) {
            obj[JSON.parse(headers[j])] = JSON.parse(row[j]);
          }
          result.push(obj);
        }
      }
      let csvData: any = result;
      // csvData.splice(csvData.length - 1, 1);
      const ws = XLSX.utils.json_to_sheet(csvData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([wbout], { type: 'application/octet-stream' });
      saveAs(blob, 'cma-statement.xlsx');
    }
  }

  resetFilter(): void {
    this.cmaForm.reset();
    this.submitted = false;
  } 
  

    startDateTime: string;
    endDateTime: string;
    currentDateTime: string;


    onStartDateTimeChange(): void {
      const now = new Date();
      const startDate = new Date(this.startDateTime);
     
      if (startDate > now) {
        this.startDateTime = now.toISOString();
        this.cmaForm.get('fromDate')?.setValue(this.startDateTime);
      }
     
      if (startDate > now) {
        this.endDateTime = now.toISOString();
        this.cmaForm.get('toDate')?.setValue(this.endDateTime);
      }
     
      if (this.endDateTime && new Date(this.endDateTime) < new Date(this.startDateTime)) {
        this.endDateTime = this.startDateTime;
        this.cmaForm.get('toDate')?.setValue(this.endDateTime);
      }
     
      this.cmaForm.get('fromDate')?.markAsTouched();
      this.cmaForm.get('toDate')?.markAsTouched();
     
      this.cmaForm.get('fromDate')?.updateValueAndValidity();
      this.cmaForm.get('toDate')?.updateValueAndValidity();
    }
   
   
    onEndDateTimeChange(): void {
      const now = new Date();
     
      if (this.endDateTime && new Date(this.endDateTime) > now) {
        const currentDateTime = now.toISOString().slice(0, 16);
        this.cmaForm.get('toDate')?.reset(currentDateTime);
        this.cmaForm.get('toDate')?.updateValueAndValidity();
      }
   
      if (this.endDateTime && new Date(this.endDateTime) < new Date(this.startDateTime)) {
        this.endDateTime = this.startDateTime;
      }
    }
  
  }
  
 
export function dateRangeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const fromDate = control.get('fromDate')?.value;
    const toDate = control.get('toDate')?.value;

    if (fromDate && toDate && new Date(fromDate) > new Date(toDate)) {
      return { 'dateRangeInvalid': true };
    }

    return null; // Return null when validation passes
  };

  
}
